import { mainSiteUrl } from "@/mocks/categories";

export default function CTASection() {
  return (
    <section className="w-full flex flex-col lg:flex-row">
      <div className="w-full lg:w-1/2 relative min-h-[320px] md:min-h-[420px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Beautifully%20styled%20flat%20lay%20of%20premium%20leather%20goods%20including%20wallets%20belts%20and%20key%20accessories%20arranged%20on%20a%20warm%20terracotta%20linen%20fabric%20surface%20soft%20diffused%20natural%20window%20light%20coming%20from%20above%20creating%20gentle%20shadows%20editorial%20luxury%20photography%20refined%20textures%20visible%20warm%20earthy%20tones%20sophisticated%20composition&width=1200&height=800&seq=cta-left-v2&orientation=landscape"
          alt="Mulebuy spreadsheet shopping experience"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50/85 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-6 md:p-10">
          <p className="text-xs md:text-sm font-bold text-foreground-600 uppercase tracking-wider mb-2">
            Get Started Today
          </p>
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 leading-[1.05] tracking-tight">
            Ready to<span className="block">Transform Your</span><span className="block">Agent Shopping?</span>
          </h2>
        </div>
      </div>

      <div className="w-full lg:w-1/2 bg-background-50 flex items-center justify-center p-8 md:p-12 lg:p-16">
        <div className="max-w-md text-center lg:text-left">
          <h3 className="font-heading text-xl md:text-3xl font-black text-foreground-950 leading-[1.1] tracking-tight">
            Join Thousands<span className="block">Using Mulebuy</span>
          </h3>
          <p className="mt-4 md:mt-6 text-sm md:text-base text-foreground-600 leading-relaxed">
            The <strong className="text-foreground-900">mulebuy spreadsheet</strong> system has already helped 
            thousands of buyers streamline their agent shopping workflow. Start organizing your orders, 
            comparing prices, and improving efficiency today with the most advanced tracking solution available.
          </p>
          <div className="flex flex-col sm:flex-row items-center gap-4 mt-6 md:mt-8">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3 bg-secondary-600 text-white rounded-full font-bold text-sm md:text-base hover:bg-secondary-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              Mulebuy Spreadsheet
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-1 px-8 py-3 border border-secondary-300 text-secondary-700 rounded-md font-semibold text-sm md:text-base hover:bg-secondary-50 transition-colors cursor-pointer whitespace-nowrap"
            >
              Buy It Now
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-xs"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}